/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'drag-horizontal-variant': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21 11H3V9h18v2m0 2H3v2h18v-2z"/>'
  }
})
